import PropTypes from 'prop-types';
import { Navigate, Outlet } from 'react-router-dom';
import LoadingScreen from '../components/LoadingScreen';
import { useModules } from '../contexts/ModuleContext';

ModuleGuard.propTypes = {
  appModule: PropTypes.string.isRequired,
  children: PropTypes.node,
};

/**
 * Blocks dashboard routes for company `admin` users when tracker API denies the module.
 * `super-admin` and legacy profiles (no `role`) pass through.
 */
export default function ModuleGuard({ appModule, children }) {
  const { isCompanyAdmin, loading, canAccessAppModule } = useModules();
  const content = children ?? <Outlet />;

  if (isCompanyAdmin && loading) {
    return <LoadingScreen isDashboard />;
  }

  if (isCompanyAdmin && !canAccessAppModule(appModule)) {
    return <Navigate to="/admin/UnauthorizedPage" replace />;
  }

  return content;
}
